import { render, staticRenderFns } from "./orderStore.vue?vue&type=template&id=24e2ad40&scoped=true"
import script from "./orderStore.vue?vue&type=script&lang=js"
export * from "./orderStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e2ad40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e2ad40')) {
      api.createRecord('24e2ad40', component.options)
    } else {
      api.reload('24e2ad40', component.options)
    }
    module.hot.accept("./orderStore.vue?vue&type=template&id=24e2ad40&scoped=true", function () {
      api.rerender('24e2ad40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/component/orderStore.vue"
export default component.exports